// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Extract from an AnalyzeResult the fields that are produced from layout analysis.
 * @internal
 */
export function toLayoutResult(analyzeResult) {
  var pages = analyzeResult.pages,
      tables = analyzeResult.tables,
      styles = analyzeResult.styles;
  return {
    pages: pages,
    tables: tables,
    styles: styles
  };
}